import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, TypeOf, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import {useLocation} from "react-router";

import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";



import TimberClassFormSelect from "../../../../timber/components/timberClass/TimberClassForm/TimberClassFormSelect";
import { PrimaryTimberClass } from "../../../../timber/types/models/TimberClass.ts";
import { t, msg } from "@lingui/core/macro"














export const initialFormStateFn = () => { return {
    
        
        name: "",
        
    
        
        description: "",
        
    
        
        minDiameter: "",
        
    
        
        maxDiameter: "",
        
    
        
        reportNameShort: "",
        
    
        
        reportNameLong: "",
        
    
        
        classId: null,
        
    
} }

export const useLocationFormState = (oldState) => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    

    return initialFormState
}

export const formObject = {
    
    
        name:
        string()
        .trim()
        .min(1, msg`Name is required`),
    
    
        description:
        string()
        .trim()
        .nullish(),
    
    
        minDiameter:
        number()
                     .gt(0).transform((value) => (!value ? null : value))
                    .and(coerce.number(msg`must be a number.`)),
    
    
        maxDiameter:
        number()
                     .gt(0).transform((value) => (!value ? null : value))
                    .and(coerce.number(msg`must be a number.`)),
    
    
        reportNameShort:
        string()
        .trim()
        .nullish(),
    
    
        reportNameLong:
        string()
        .trim()
        .nullish(),
    
    
        classId:
        string()
                .nanoid(msg`Timber Class is required`)
                .nullish(),
    
};

export const formSchema = object(formObject);

const ThicknessClassUpdateForm = ({watch, prefix = ''})  => {
    return (
        <Container>
            
            
   
   <crudgen.FormInput
       required
       name={ prefix + 'name' }
       aria-label="name"
       data-testid="name"
       label={t`Name`}
       
       type='text'
       
   />
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'description' }
       aria-label="description"
       data-testid="description"
       label={t`Description`}
       
       type='text'
       
   />
   
   
            
            
   
   <crudgen.FormInput
       required
       name={ prefix + 'minDiameter' }
       aria-label="minDiameter"
       data-testid="minDiameter"
       label={t`Min Diameter`}
       
       type='number'
       checkNumber={true}
       forceNumber={true}
       
   />
   
   
            
            
   
   <crudgen.FormInput
       required
       name={ prefix + 'maxDiameter' }
       aria-label="maxDiameter"
       data-testid="maxDiameter"
       label={t`Max Diameter`}
       
       type='number'
       checkNumber={true}
       forceNumber={true}
       
   />
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'reportNameShort' }
       aria-label="reportNameShort"
       data-testid="reportNameShort"
       label={t`Report Name Short`}
       
       type='text'
       
   />
   
   
            
            
   
   <crudgen.FormInput
       
       name={ prefix + 'reportNameLong' }
       aria-label="reportNameLong"
       data-testid="reportNameLong"
       label={t`Report Name Long`}
       
       type='text'
       
   />
   
   
            
            
   
    
    <TimberClassFormSelect
        type="dynamicSelect"
        name="classId"
        label={t`Timber Class`}
        prefix={prefix}
        required={ false }
    />
   
   
   
            
        </Container>
    )
}

export default ThicknessClassUpdateForm;
